<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big" translate>UPLOADER_PASSWORD_REQUIRED_TITLE</div>
    </div>
    <div class="body">
        <div class="section">
            <p translate>UPLOADER_PASSWORD_REQUIRED_TEXT1</p>
            <form [formGroup]="passwordForm" class="form-section">
                <div class="form-input">
                    <app-smash-fake-password 
                        type="text" 
                        borderStyle="full"                         
                        placeholder="{{'UPLOADER_INPUT_PLACHOLDER_PASSWORD' | translate}}"
                        formControlName="password"
                        [error]="submitted && f.password.errors">
                        <div *ngIf="submitted && f.password.errors" error>
                            <span translate>UPLOADER_CONFIG_SMASH_SUBTITLE_PASSWORD_ERROR</span>
                        </div>
                    </app-smash-fake-password>
                </div>
            </form>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new white" (click)="closeModal()"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="onSubmit()" type="submit"
            translate>UPLOADER_PASSWORD_REQUIRED_SAVE</button>
    </div>
</div>